/* ============================================================
   MsDressly A11y Layer — progressive keyboard/AT support
   - Makes [role="button"][tabindex] elements operable with
     Enter/Space (div-based option values, icon triggers).
   - Keeps aria-pressed in sync with the theme's .active class
     on [data-js-option-value] option swatches.
   - No dependencies, delegated listeners, idempotent.
   ============================================================ */
(function () {
  'use strict';

  /* ─── Enter/Space activates div-based buttons ────────────── */
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' && event.key !== ' ' && event.key !== 'Spacebar') return;
    var target = event.target;
    if (!target || !target.closest) return;
    var btn = target.closest('[role="button"][tabindex]');
    if (!btn) return;
    if (btn.getAttribute('aria-disabled') === 'true') return;
    /* Let real buttons/links keep their native behavior. */
    if (btn.tagName === 'BUTTON' || btn.tagName === 'A' || btn.tagName === 'INPUT') return;
    event.preventDefault();
    btn.click();
  });

  /* ─── Sync aria-pressed with the theme's .active class ───── */
  function syncPressed(scope) {
    (scope || document).querySelectorAll('[data-js-option-value][role="button"]').forEach(function (el) {
      el.setAttribute('aria-pressed', el.classList.contains('active') ? 'true' : 'false');
    });
  }

  /* Theme toggles .active on click; re-sync after it handles the event. */
  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;
    if (!target.closest('[data-js-option-value]')) return;
    window.setTimeout(function () {
      var section = target.closest('[data-property]') || document;
      syncPressed(section.parentNode || document);
    }, 0);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { syncPressed(document); });
  } else {
    syncPressed(document);
  }
})();
